<template>
    <div
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                BERITA ACARA SARANA
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                    enctype="multipart/form-data"
                >
                    <div class="mb-3">
                        <label class="form-label" for="nomorLambung"
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <input
                            type="hidden"
                            name="_token"
                            v-model="csrfTokens"
                        />
                        <select
                            class="form-control"
                            id="nomorLambung"
                            name="kodeUnit"
                            placeholder="NOMOR LAMBUNG"
                            v-model="this.lampiran.kodeUnit"
                            @change="selectSarana($event)"
                            required="required"
                        >
                        <option value="" selected="selected">-- Pilih --</option>
                        <option  v-for="(i,k) in sarana" :value="k"> {{ i }}</option>
                    </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmMeter">Kilometer Unit</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kilometerUnit"
                            v-model="lampiran.kilometerUnit"
                            placeholder="Kilometer Unit"
                            required="required"
                            @keypress="isNumber($event)"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="judulBA">Subjek Berita Acara</label>
                        <input
                            type="text"
                            class="form-control"
                            id="judulBA"
                            v-model="lampiran.judulBA"
                            placeholder="Subjek Berita Acara"
                            required="required"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="keteranganBA">Keterangan Berita Acara</label>
                        <textarea
                            type="text"
                            class="form-control"
                            id="judulBA"
                            v-model="lampiran.keteranganBA"
                            placeholder="Keterangan Berita Acara"
                            required="required"
                            rows="5"
                        ></textarea>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="lampiranBA">Lampiran Berita Acara</label>
                        <input
                            type="text"
                            class="form-control"
                            id="lampiranBA"
                            name="lampiranBA"
                            v-model="lampiran.lampiranBA"
                            placeholder="Lampiran Berita Acara"
                            required="required"
                            @keypress="disabledInput"
                            @click="klikLampiran()"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="merkType">MEREK - Type</label>
                        <input
                            type="text"
                            class="form-control"
                            id="merkType"
                            v-model="lampiran.merkType"
                            placeholder="MEREK - Type"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="tanggal"
                            >Tanggal</label
                        >
                        <input
                            type="date"
                            class="form-control"
                            id="tanggal"
                            v-model="lampiran.tanggal"
                            required="required"
                            readonly="readonly"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="jam">Waktu</label>
                        <input
                            type="time"
                            class="form-control"
                            id="jam"
                            v-model="lampiran.jam"
                            placeholder="Waktu"
                            step="2"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="userinput">Dibuat Oleh</label>
                        <input
                            type="text"
                            class="form-control"
                            id="userinput"
                            v-model="lampiran.nama"
                            placeholder="Dibuat Oleh"
                            step="2"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <button
                        type="submit"
                        class="btn btn-primary me-3 data-submit"
                    >
                        Submit
                    </button>
                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
        <berita-acara-lampiran @beritaAcaraEmit="doEmit"></berita-acara-lampiran>
    </div>
</template>
<script>
import axios from "axios";
import { uid } from 'uid';
import moment from "moment";
export default {
    mounted() {
        if (this.username != "")
            this.users = JSON.parse(this.username);
        this.getSarana();
        if(this.idsarana!=null) this.lampiran.kodeUnit=this.idsarana
    },
    data() {
        return {
            moment:moment,
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            lampiran: {},
            sarana: [],
            vehicle : [],
            chkStatus: true,
            idVehicles: null,
            users:{},
            nomorBA:uid(),
            dtime:new Date()
        };
    },
    props: ["tokens", "url_action","username","idsarana"],
    methods: {
        send() {
                 this.save();
        },
        save() {
            var a = this
            a.nomorBA = uid()
            a.lampiran.nomorBA = a.nomorBA
            var l = a.lampiran
            axios.put("/sarana/ba/"+l.uidVehicle, l).then((response) => {
                var data = response.data;
                if (data.success) {
                    document.location = data.uri
                }
            });
        },
        getSarana() {
            this.initDatas();
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        var vhc = {};
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                    this.changeSarana(this.lampiran.kodeUnit)
                });
        },
        getUid() {
            axios.get("/get/uids").then((response) => {
                this.lampiran.uidVehicle = response.data;
            });
        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57)
            ) {
                evt.preventDefault();
            }
            },
        chgStatus() {
            this.chkStatus != this.chkStatus;
            if (this.chkStatus) {
                this.lampiran.statusCeklog = 1;
            } else {
                this.lampiran.statusCeklog = 0;
            }
        },
        selectSarana(e){
            var v = this.vehicle[e.target.value]
            this.lampiran.noLambung = this.sarana[e.target.value];
            this.lampiran.merkType = v
            this.lampiran.kodeUnit = e.target.value;
        },

        changeSarana(e){
            var v = this.vehicle[e]
            this.lampiran.noLambung = this.sarana[e];
            this.lampiran.merkType = v
            this.lampiran.kodeUnit = e;
        },
        klikLampiran(){
            var myOffcanvas = document.getElementById("offcanvasLampiran");
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
            return false
        },
        initDatas() {
            var hari=['Minggu', 'Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'];
            var time =this.pad(this.dtime.getHours())+':'+this.pad(this.dtime.getMinutes())+':'+this.pad(this.dtime.getSeconds())
            var dt = moment().format('YYYY-MM-DD')

            this.lampiran = {};
            if (this.url_action != null) {
                this.urlAction = this.url_action;
            }
            if (this.tokens != null) {
                this.csrfTokens = this.tokens;
            }
            this.lampiran.kodeUnit = "";
            this.lampiran.status = 1;
            this.lampiran.tanggal =dt
            this.lampiran.jam = time
            this.lampiran.hari = hari[this.dtime.getDay()];
            this.lampiran.userInput = this.users.username
            this.lampiran.nama = this.users.fullName
            this.getUid();
        },
        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString();
        },
        doEmit(e){
            this.lampiran.lampiranBA = e
        },
        disabledInput(e){
            e.preventDefault();
        }
    },
    expose: ["initDatas"],
};
</script>